import { NavContext } from "../Document"
import cx from "classnames"
import * as styles from "./styles.module.scss"
import React, { useContext } from "react"

interface HamburgerProps {
  className?: string
}

const Hamburger: React.FC<HamburgerProps> = ({ className }) => {
  const { isNavOpen, toggleNav } = useContext(NavContext)
  return (
    <button
      className={cx({
        [styles.hamburger]: true,
        [styles.active]: isNavOpen,
        [className]: !!className,
      })}
      data-qa="hamburger"
      onClick={toggleNav}
    >
      <div className={styles.top} />
      <div className={styles.middle} />
      <div className={styles.bottom} />
    </button>
  )
}

export default Hamburger
